/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Export_PortalsInputs */

const cs_filter_export_portals = /** @type {(inputs: Filter_Export_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export na portály`)
};

const en_filter_export_portals = /** @type {(inputs: Filter_Export_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export to portals`)
};

/**
* | output |
* | --- |
* | "Export to portals" |
*
* @param {Filter_Export_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_export_portals = /** @type {((inputs?: Filter_Export_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Export_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_export_portals(inputs)
	return cs_filter_export_portals(inputs)
});